var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-crud-page',{attrs:{"master":"fuel_type","title":"Fuel Type","access":"master_fuel_type","pk":"mftyId","columns":_vm.columns,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }